// Gesetzliche Feiertage in Nordrhein-Westfalen, berechnet statt hartkodiert.
// Rückgabeformat wie die frühere FT-Tabelle: { '04': [18, 21], '05': [1, 29], ... }
// (Schlüssel = Monat zweistellig, Werte = Tage im Monat).

// Osterdatum nach dem Gauß-Verfahren (gregorianischer Kalender), liefert Date (lokal).
function ostersonntag(jahr) {
  const a = jahr % 19
  const b = Math.floor(jahr / 100)
  const c = jahr % 100
  const d = Math.floor(b / 4)
  const e = b % 4
  const f = Math.floor((b + 8) / 25)
  const g = Math.floor((b - f + 1) / 3)
  const h = (19 * a + b - d - g + 15) % 30
  const i = Math.floor(c / 4)
  const k = c % 4
  const l = (32 + 2 * e + 2 * i - h - k) % 7
  const m = Math.floor((a + 11 * h + 22 * l) / 451)
  const monat = Math.floor((h + l - 7 * m + 114) / 31) // 3 = März, 4 = April
  const tag = ((h + l - 7 * m + 114) % 31) + 1
  return new Date(jahr, monat - 1, tag)
}

function plusTage(datum, tage) {
  const d = new Date(datum.getTime())
  d.setDate(d.getDate() + tage)
  return d
}

const cache = {}

// Alle gesetzlichen Feiertage NRW für ein Jahr.
export function feiertage(jahr) {
  jahr = parseInt(jahr, 10)
  if (isNaN(jahr)) return {}
  if (cache[jahr]) return cache[jahr]

  const ostern = ostersonntag(jahr)
  const beweglich = [
    plusTage(ostern, -2), // Karfreitag
    plusTage(ostern, 1),  // Ostermontag
    plusTage(ostern, 39), // Christi Himmelfahrt
    plusTage(ostern, 50), // Pfingstmontag
    plusTage(ostern, 60), // Fronleichnam (NRW)
  ]
  const fest = [
    [1, 1],   // Neujahr
    [5, 1],   // Tag der Arbeit
    [10, 3],  // Tag der Deutschen Einheit
    [11, 1],  // Allerheiligen (NRW)
    [12, 25], // 1. Weihnachtstag
    [12, 26], // 2. Weihnachtstag
  ]

  const result = {}
  const add = (monat, tag) => {
    const key = (monat < 10 ? '0' : '') + monat
    if (!result[key]) result[key] = []
    result[key].push(tag)
  }
  fest.forEach(([m, t]) => add(m, t))
  beweglich.forEach(d => add(d.getMonth() + 1, d.getDate()))
  Object.keys(result).forEach(k => result[k].sort((x, y) => x - y))

  cache[jahr] = result
  return result
}

// Komfortfunktion für die Komponenten: jahr/monat als String oder Zahl, tag als Zahl.
export function istFeiertag(jahr, monat, tag) {
  const ft = feiertage(jahr)
  const m = parseInt(monat, 10)
  const key = (m < 10 ? '0' : '') + m
  return key in ft && ft[key].indexOf(parseInt(tag, 10)) !== -1
}
